import { useCallback } from 'react';

import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { useLessonStorage } from '../../../hooks';
import { ExercisePage, MAX_CHARACTER_COUNT } from '../../Interactive/WorksheetActivity/exercisePage';
import {
  StyledImageContainer, StyledSharedAsset, StyledList, StyledTextArea, StyledNextButton
} from '../../Interactive/WorksheetActivity/useStyles';

const NEXT_BUTTON_TEXT = 'Next';
export const I_CAN_GET_PAID_FOR = 'iCanGetPaidFor';

export const WhatYouCanGetPaidFor = ({ onNext }) => {
  const { lesson } = useParams();
  const { getStorageValue, setStorageValue, saveChanges } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const onNextHandler = useCallback(() => {
    saveChanges();
    onNext();
  }, [saveChanges, onNext]);

  const presentation = (
    <StyledImageContainer>
      <StyledSharedAsset
        src="/journey%20to%20success/01%20MVE%20Series/01%20PEAKS/mve_peaks_exercise4.svg"
        alt="ikigai-exercise"
        width={500}
      />
    </StyledImageContainer>
  );

  return (
    <ExercisePage
      caption="Exercise"
      title="What you can get paid for &#128181;"
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      isButtonDisabled={!getStorageValue(I_CAN_GET_PAID_FOR)}
      onNext={onNextHandler}
    >
      <Text size={isMobile ? 'lg' : 'sm'} bold>Ask yourself:</Text>
      <StyledList>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What products or services have people offered to pay me for?</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>Do people express interest in my product or service?</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>Are other people successful at selling a similar product or service?</Text>
        </li>
      </StyledList>
      <StyledTextArea
        placeholder="I can get paid for..."
        text={getStorageValue(I_CAN_GET_PAID_FOR)}
        onChangeHandler={(e) => setStorageValue(I_CAN_GET_PAID_FOR, e.target.value)}
        maxLength={MAX_CHARACTER_COUNT}
      />
      {!isMobile && (
      <StyledNextButton
        className="buttonRight"
        variant="contained"
        color="primary"
        size="large"
        disabled={!getStorageValue(I_CAN_GET_PAID_FOR)}
        onClick={() => onNextHandler()}
      >
        {NEXT_BUTTON_TEXT}
      </StyledNextButton>
      )}
    </ExercisePage>
  );
};

WhatYouCanGetPaidFor.propTypes = {
  onNext: PropTypes.func
};

WhatYouCanGetPaidFor.defaultProps = {
  onNext: () => {}
};

export default WhatYouCanGetPaidFor;
